import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message , Tag} from 'antd';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号', width: 75},
    {key:'employeeCode', label: '职工号', width: 100},
    {key:'realName', label: '姓名', width: 60},
    {key:'itemName', label: '评价方名称', width: 100},
    {key:'evalName', label: '指标名称', width: 100},
    {key:'attendanceTime', label: '被评次数', width: 40},
    {key:'termName', label: '所属学期', width: 100},
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;
    var params = [];
    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        }  else if(i === 'order'){
            params.push(`order=${keywords[i]}`);
        } else {
        }
    }

    return fetch.post('attendanceTime/query?'+ params.join('&'),  Object.assign(defaultsParams, keywords))
    // return fetch.mockget('http://test.gxjxcp.com:8888/mock/11/jxcp-webapp/listenManager')
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta
        };
    })
    .then(response => (Object.assign({ 
        result: response.data.dataList || [],
        checked: false,
        meta: response.meta,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method querySearchTarget
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchTarget = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('attendanceTime/target/tree', keywords)
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(utils.tree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'listen/assign'+ url;
};


export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    redirect,
    getSelection,
    querySearchTarget,
}